/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from './types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
export type SocialUserFollowersQueryVariables = Types.Exact<{
  input: Types.UserFollowersInput;
}>;


export type SocialUserFollowersQuery = { __typename?: 'Query', userFollowers?: { __typename?: 'UserFollowersResponse', followers?: Array<{ __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean }> | null, pagination: { __typename?: 'UserFollowersPagination', totalPages: number, itemsPerPage: number, currentPage: number }, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type SocialUserFollowingQueryVariables = Types.Exact<{
  input: Types.UserFollowersInput;
}>;


export type SocialUserFollowingQuery = { __typename?: 'Query', userFollowing?: { __typename?: 'UserFollowingResponse', following?: Array<{ __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean }> | null, pagination: { __typename?: 'UserFollowersPagination', totalPages: number, itemsPerPage: number, currentPage: number }, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type SocialUserFollowersCountQueryVariables = Types.Exact<{
  input: Types.UserFollowersCountInput;
}>;


export type SocialUserFollowersCountQuery = { __typename?: 'Query', userFollowersCount?: { __typename?: 'UserFollowersCountResponse', FollowersCount: number, FollowingCount: number, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } | null };

export type ClubhousesFromUserQueryVariables = Types.Exact<{
  input: Types.ClubhousesFromUserInput;
}>;


export type ClubhousesFromUserQuery = { __typename?: 'Query', clubhousesFromUser: { __typename?: 'ClubhousesFomUserResponse', clubhouses?: Array<{ __typename?: 'Clubhouse', name: string, slug: string, type: Types.ClubhouseType, query: string, digitalAssetsFilters?: Array<string> | null, askTopics?: Array<string> | null, membersTotal: number, isMember: boolean, isSubscribedToDigest: boolean, icon?: string | null, avatarImage?: string | null, bannerImage?: string | null, bgColor?: string | null, lightBgColor?: string | null, textColor?: string | null }> | null, pagination?: { __typename?: 'ClubhousesListPagination', page: number, totalPages: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialLatestDownloadImagesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SocialLatestDownloadImagesQuery = { __typename?: 'Query', socialLatestDownloadImages: { __typename?: 'SocialLatestDownloadImagesResponse', images?: Array<string> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };


export const SocialUserFollowersDocument = `
query socialUserFollowers($input: UserFollowersInput!) {
  userFollowers(input: $input) {
    followers {
      id
      slug
      displayName
      firstName
      lastName
      shopName
      avatarUrl
      isCreativeFabrica
      isVerified
      isPremium
      isFollowed
      following
      isTemporary
    }
    pagination {
      totalPages
      itemsPerPage
      currentPage
    }
    errors {
      code
      message
    }
  }
}

`

export const socialUserFollowersQueryRootKey = 'socialUserFollowers'

export function socialUserFollowersQueryFetcher(variables: SocialUserFollowersQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialUserFollowersQuery, SocialUserFollowersQueryVariables>(SocialUserFollowersDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialUserFollowersQueryKey(variables: SocialUserFollowersQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialUserFollowersQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialUserFollowersQueryOptions(
    variables: SocialUserFollowersQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialUserFollowersQuery, unknown, SocialUserFollowersQuery, (SocialUserFollowersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialUserFollowersQueryKey(variables, fetchOptions),
        queryFn: socialUserFollowersQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialUserFollowersQuery<D = SocialUserFollowersQuery, E = unknown>(
    variables: SocialUserFollowersQueryVariables,
    options?: Omit<UseQueryOptions<SocialUserFollowersQuery, E, D, (SocialUserFollowersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialUserFollowersQuery, E, D, (SocialUserFollowersQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialUserFollowersQueryOptions(variables, fetchOptions),
    })
}

export const SocialUserFollowingDocument = `
query socialUserFollowing($input: UserFollowersInput!) {
  userFollowing(input: $input) {
    following {
      id
      slug
      displayName
      firstName
      lastName
      shopName
      avatarUrl
      isCreativeFabrica
      isVerified
      isPremium
      isFollowed
      following
      isTemporary
    }
    pagination {
      totalPages
      itemsPerPage
      currentPage
    }
    errors {
      code
      message
    }
  }
}

`

export const socialUserFollowingQueryRootKey = 'socialUserFollowing'

export function socialUserFollowingQueryFetcher(variables: SocialUserFollowingQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialUserFollowingQuery, SocialUserFollowingQueryVariables>(SocialUserFollowingDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialUserFollowingQueryKey(variables: SocialUserFollowingQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialUserFollowingQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialUserFollowingQueryOptions(
    variables: SocialUserFollowingQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialUserFollowingQuery, unknown, SocialUserFollowingQuery, (SocialUserFollowingQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialUserFollowingQueryKey(variables, fetchOptions),
        queryFn: socialUserFollowingQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialUserFollowingQuery<D = SocialUserFollowingQuery, E = unknown>(
    variables: SocialUserFollowingQueryVariables,
    options?: Omit<UseQueryOptions<SocialUserFollowingQuery, E, D, (SocialUserFollowingQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialUserFollowingQuery, E, D, (SocialUserFollowingQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialUserFollowingQueryOptions(variables, fetchOptions),
    })
}

export const SocialUserFollowersCountDocument = `
query socialUserFollowersCount($input: UserFollowersCountInput!) {
  userFollowersCount(input: $input) {
    FollowersCount
    FollowingCount
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialUserFollowersCountQueryRootKey = 'socialUserFollowersCount'

export function socialUserFollowersCountQueryFetcher(variables: SocialUserFollowersCountQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialUserFollowersCountQuery, SocialUserFollowersCountQueryVariables>(SocialUserFollowersCountDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialUserFollowersCountQueryKey(variables: SocialUserFollowersCountQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialUserFollowersCountQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialUserFollowersCountQueryOptions(
    variables: SocialUserFollowersCountQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialUserFollowersCountQuery, unknown, SocialUserFollowersCountQuery, (SocialUserFollowersCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialUserFollowersCountQueryKey(variables, fetchOptions),
        queryFn: socialUserFollowersCountQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialUserFollowersCountQuery<D = SocialUserFollowersCountQuery, E = unknown>(
    variables: SocialUserFollowersCountQueryVariables,
    options?: Omit<UseQueryOptions<SocialUserFollowersCountQuery, E, D, (SocialUserFollowersCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialUserFollowersCountQuery, E, D, (SocialUserFollowersCountQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialUserFollowersCountQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesFromUserDocument = `
query clubhousesFromUser($input: ClubhousesFromUserInput!) {
  clubhousesFromUser(input: $input) {
    clubhouses {
      name
      slug
      type
      query
      digitalAssetsFilters
      askTopics
      membersTotal
      isMember
      isSubscribedToDigest
      icon
      avatarImage
      bannerImage
      bgColor
      lightBgColor
      textColor
    }
    pagination {
      page
      totalPages
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesFromUserQueryRootKey = 'clubhousesFromUser'

export function clubhousesFromUserQueryFetcher(variables: ClubhousesFromUserQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesFromUserQuery, ClubhousesFromUserQueryVariables>(ClubhousesFromUserDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesFromUserQueryKey(variables: ClubhousesFromUserQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesFromUserQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesFromUserQueryOptions(
    variables: ClubhousesFromUserQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesFromUserQuery, unknown, ClubhousesFromUserQuery, (ClubhousesFromUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesFromUserQueryKey(variables, fetchOptions),
        queryFn: clubhousesFromUserQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesFromUserQuery<D = ClubhousesFromUserQuery, E = unknown>(
    variables: ClubhousesFromUserQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesFromUserQuery, E, D, (ClubhousesFromUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesFromUserQuery, E, D, (ClubhousesFromUserQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesFromUserQueryOptions(variables, fetchOptions),
    })
}

export const SocialLatestDownloadImagesDocument = `
query socialLatestDownloadImages {
  socialLatestDownloadImages {
    images
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialLatestDownloadImagesQueryRootKey = 'socialLatestDownloadImages'

export function socialLatestDownloadImagesQueryFetcher(variables?: SocialLatestDownloadImagesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialLatestDownloadImagesQuery, SocialLatestDownloadImagesQueryVariables>(SocialLatestDownloadImagesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialLatestDownloadImagesQueryKey(variables?: SocialLatestDownloadImagesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialLatestDownloadImagesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function socialLatestDownloadImagesQueryOptions(
    variables?: SocialLatestDownloadImagesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialLatestDownloadImagesQuery, unknown, SocialLatestDownloadImagesQuery, (SocialLatestDownloadImagesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialLatestDownloadImagesQueryKey(variables, fetchOptions),
        queryFn: socialLatestDownloadImagesQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialLatestDownloadImagesQuery<D = SocialLatestDownloadImagesQuery, E = unknown>(
    variables?: SocialLatestDownloadImagesQueryVariables,
    options?: Omit<UseQueryOptions<SocialLatestDownloadImagesQuery, E, D, (SocialLatestDownloadImagesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialLatestDownloadImagesQuery, E, D, (SocialLatestDownloadImagesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialLatestDownloadImagesQueryOptions(variables, fetchOptions),
    })
}